jQuery(function ($) {

    $.expr[":"].external = function (a) {
        //var linkhref = a.hostname;
        //var domainhref = location.hostname;

        var linkhn = a.hostname.split('.').reverse();
        var linkhref = linkhn[1] + "." + linkhn[0];

        var domainhn = window.location.hostname.split('.').reverse();
        var domainhref = domainhn[1] + "." + domainhn[0];

        console.log(a, linkhn, domainhn);

        return !a.href.match(/^mailto\:/) && !a.href.match(/^tel\:/) && linkhref !== domainhref;
    };


    $(function () {

        $("a").click(function (e) {
console.log('NHUSD.external_links',NHUSD.external_links);

            if (NHUSD.external_links && $(this).is(':external')) {
                // open a modal
                e.preventDefault();

                console.log('ccccccc', );

                //go to link on modal close
                var url = $(this).attr('href');
                let target = $(this).attr('target');

                $('.modal-body p').html('Please press Continue to go ' + url);

                $('.btn-modal.btn-continue').click(function () {
                    if (target == '_blank') {
                        window.open(url); // will open it in new window
                    }else{
                        document.location.href = url // if you want it to open in same window
                    }
                    $('.btn-modal.btn-continue').off();
                });
                $('.btn-modal.btn-close').click(function () {
                    $('#speedbump').modal('hide');
                    $('.btn-modal.btn-close').off();

                });
                $('#speedbump').modal()
            }
        });

    });


    if ($('section.faqs').length > 0) {
        $('.card-header').click(function () {
            var translate = GTranslateGetCurrentLang();
            if (translate !== null && translate !== 'en') {
                doGTranslate('en|' + translate);
            }
        });

    }
    /* ==================================================================================================
        Show Search Form
    ================================================================================================== */
    (function () {
        $(".search-icon-form").on("click", function () {
            $("#search-form").addClass("active");
        });
        $(".top-bar .search-item .nav-link").on("click", function () {
            $("#search-form").addClass("active");
        });
        $("#search-form .close").on("click", function () {
            $("#search-form").removeClass("active");
        });
    })();

    /* ==================================================================================================
        Mega Menu
    ================================================================================================== */
    (function () {
        let mega_menu = $('#mega-menu'),
            sticky_navbar_menu = $('.sticky-navbar-menu');


        let get_left_position_of_home_svg = function (id) {
            let elem = document.getElementById(id);
            return elem.getBoundingClientRect().left;
        }
        const MM = document.getElementById('mega-menu');

        if ($(window).scrollTop() >= 200) {
            MM.style.left = get_left_position_of_home_svg('sticky-navbar-menu__menu-svg') + "px";
            $(window).resize(function () {
                MM.style.left = get_left_position_of_home_svg('sticky-navbar-menu__menu-svg') + "px";
            });
        } else {
            MM.style.left = "0px";
        }

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 200) {
                sticky_navbar_menu.addClass('sticky__is-visible');
                mega_menu.addClass('position-fixed');
            } else {
                sticky_navbar_menu.removeClass('sticky__is-visible');
                mega_menu.removeClass('position-fixed');
            }
        });

        $(".mega-menu__close").on("click", function () {
            mega_menu.slideUp();
        });

        $(document).click(function (e) {
            if (mega_menu.is(":visible") == true) {
                if (!$(e.target).is('#search-form, #search-form .close, .top-bar, .top-bar * , sticky-navbar-menu__menu, .sticky-navbar-menu__menu * , .mega-menu *')) {
                    mega_menu.slideUp();
                }
            }
        });

        $(".top-bar__menu, .sticky-navbar-menu__menu").on("click", function () {
            mega_menu.slideDown();
        });

        $('#aside-menu .current-menu-item .arrow-down-blue').addClass('active');

        $(".arrow-down-blue").on("click", function (event) {
            let $this = $(this);
            event.preventDefault();
            $this.toggleClass("active");
            $this.parent().siblings().slideToggle();
        });
    })();

    /* ==================================================================================================
        Input Pagination
    ================================================================================================== */
    $('.pagination-wrapper.input-pagination input.inputPagination').keypress(function (e) {
        if (e.which == 13) {
            var base = $(this).attr('data-base');
            var new_page = $(this).val();
            var new_url = base.replace("%#%", new_page);
            window.location.assign(new_url);
        }
    });

    /* ==================================================================================================
        Glightbox
    ================================================================================================== */
    if ($('.glightbox3').length > 0) {
        let lightboxVideo = GLightbox({
            selector: '.glightbox3'
        });
    }


    /* ==================================================================================================
        Add a class That change the <blockquote> ELS -> Page
    ================================================================================================== */
    $(".info-families__content blockquote").each(function (index) {
        $(this)
            .find('img')
            .parent('blockquote')
            .addClass("blockquote-with-image");
    });

    /* ==================================================================================================
        Hero Carousel
    ================================================================================================== */
    let carousel = $('.carousel');
    if (carousel.length > 0) {
        carousel.carousel({
            interval: 5000,
        })
    }


});

// Open external links in a popup modal notice
